import { Switch } from 'antd'
import { type LibraDashboardConfig } from 'features/libra/dashboard/libraDashboardApi'
import { useToggleRoiVisible } from 'features/libra/dashboard/useToggleRoiVisible'
import type { FC } from 'react'
import styled from 'styled-components'

type RoiVisibilityToggleProps = {
  config: LibraDashboardConfig
}

export const RoiVisibilityToggle: FC<RoiVisibilityToggleProps> = ({
  config,
}) => {
  const { isGeckoInternal, isOptedIn, saving, setVisible } =
    useToggleRoiVisible(config)

  if (!isGeckoInternal) return null

  return (
    <ToggleRow>
      <ToggleLabel htmlFor='show-campaign-roi'>
        Show campaign ROI for me
      </ToggleLabel>
      <Switch
        id='show-campaign-roi'
        size='small'
        checked={isOptedIn}
        loading={saving}
        disabled={saving}
        onChange={setVisible}
      />
    </ToggleRow>
  )
}

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-width: 16rem;
  padding-top: 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.forecast.border};
`

const ToggleLabel = styled.label`
  margin: 0;
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  cursor: pointer;
`
